module.exports = __webpack_public_path__ + "img/tv-thati-record-new.85780706.png";